import React from 'react';
import { useTranslation } from 'react-i18next';
import { NumperInputProps } from './Types';
import InputLabel from './InputLabel';
const NumberInput = ({
  label,
  shape = 'squre',
  color = 'textPrimary',
  bg = 'white',
  onChange,
  name,
  prefix,
  suffix,
  required = false,
  value,
  placeholder = 'add number',
  max,
  min,
}: NumperInputProps) => {
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    e.preventDefault();
    onChange(name, Number(e.target.value));
  };

  const { t } = useTranslation();

  return (
    <div>
      {label && <InputLabel text={label} name={name} required={required} />}

      <input
        type="number"
        name={name}
        max={max}
        min={min}
        id={name}
        value={value}
        required={required}
        onChange={handleChange}
        className={`input focus:ring-ring-color shadow-sm focus:ring-4 cursor-pointer  focus:ring-opacity-10 focus:ring-offset-0  ${
          shape === 'circle' ? 'rounded-full' : 'rounded-md'
        } bg-${bg} text-${color} focus:border-primary block  ${
          prefix && 'pl-7'
        }  sm:text-sm border-gray-300 `}
        placeholder={
          t(`inputs.placeholders.${placeholder}`, placeholder || '') as string
        }
      />
    </div>
  );
};

export default NumberInput;
